import React from 'react';
import PropTypes from 'prop-types';

import 'scss/layout.scss';
import './index.scss';

export default function Section({header, children}) {
    return (
        <div className="section layout-stack">
            <div className="section__header">
                {header}
            </div>
            {children}
        </div>
    );
}

Section.propTypes = {
    children: PropTypes.arrayOf(PropTypes.object),
    header: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./components/section/index.js